<template>
	<div class="up-load-PopUp">
		<form class="dropbox-form" enctype="multipart/form-data" novalidate>
			<div class="contenido-upload">

				<div class="label-add">
						<div class="dropbox">
							<input type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" class="input-file">
							<p v-if="isInitial">
								Drag your file(s) here to begin<br> or click to browse
							</p>
							<p v-if="filesAdded">
								{{ fileCount }} files added
							</p>
							<p v-if="isSaving">
								Uploading {{ fileCount }} files...
							</p>
						</div>
				</div>

				<div class="container-select" >
				<b-form-select class="selected--uploadFiles" v-model="form.projectType" :state="$v.form.projectType.$dirty ? !$v.form.projectType.$error : null" v-if="uploadType === 'all' ">
					<option disabled value="">Please select one</option>
					<option value="New Residential Construction">New Residential Construction</option>
					<option value="A Residential Addition">A Residential Addition</option>
					<option value="Commercial or Non-Residential">Commercial or Non-Residential</option>
				</b-form-select>
				<b-form-invalid-feedback id="input-2-live-feedback">
					Project type is required
				</b-form-invalid-feedback>

				<div class="label-type" v-if="uploadType === 'a'">
					<b-alert show variant="success">New Residential Construction</b-alert>
				</div>
				<div class="label-type" v-if="uploadType === 'b'">
					<b-alert show variant="success">A Residential Addition</b-alert>
				</div>
				<div class="label-type" v-if="uploadType === 'c'">
					<b-alert show variant="success">Commercial or Non-Residential</b-alert>
				</div>
			</div>

				<div class="form-field">

						<b-row class="my-1">
							<b-col sm="2">
								<img class="icono-upload" src="~Img/baseline-font_download-24px.svg" >
							</b-col>
							<b-col sm="12" md="10">
								<b-form-input :state="$v.form.projectName.$dirty ? !$v.form.projectName.$error : null" v-model="form.projectName" :class="getValidationClass('projectName')" id="projectName" name="projectName" type="text" placeholder="Project name"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Project name is required
								</b-form-invalid-feedback>
							</b-col>
						</b-row>

						<b-row class="my-1">
							<b-col sm="2">
								<img class="icono-upload" src="~Img/baseline-account_circle-24px.svg" >
							</b-col>
							<b-col sm="12" md="10" >
								<b-form-input v-model="form.from" :state="$v.form.from.$dirty ? !$v.form.from.$error : null" id="from" name="from" type="text" placeholder="First and Last Name"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									From field is required
								</b-form-invalid-feedback>
							</b-col>
						</b-row>

						<b-row class="my-1 drop-row">
							<b-col sm="2">
								<img class="icono-upload dropboxIcon" src="~Img/dropSvgIcon.svg" >
							</b-col>

							<b-col sm="12" md="10" class="drop-check-wrap" title="With your Dropbox account, you can keep uploading files later.">
								<!-- <b-form-checkbox id="checkbox-dropbox" v-model="isDropboxOption" name="checkbox-dropbox" :value="true" :unchecked-value="false">
									<span :class="{ isDrop: isDropboxOption }">&nbsp;&nbsp;I have a Dropbox Account</span><br>
								</b-form-checkbox> -->
									<label><input type="checkbox" v-model="isDropboxOption" id="checkbox-dropbox2" :value="true">&nbsp; I have a Dropbox Account</label>
							</b-col>
						</b-row>

						<b-row class="my-1">
							<b-col sm="2">
								<img class="icono-upload" src="~Img/baseline-email-24px.svg" >
							</b-col>
							<b-col sm="12" md="10" >
								<b-form-input v-model="form.email" :state="$v.form.email.$dirty ? !$v.form.email.$error : null" id="input-default" type="email" :placeholder="isDropboxOption ? 'E-mail registered in Dropbox' : 'E-mail'"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Email is required
								</b-form-invalid-feedback>
							</b-col>
						</b-row>

						<b-row class="my-1">
							<b-col class="icono-upload" sm="2">
								<img src="~Img/baseline-call-24px.svg" >
							</b-col>
							<b-col sm="12" md="10" >
								<b-form-input v-model="form.phone" :state="$v.form.phone.$dirty ? !$v.form.phone.$error : null" id="input-default" type="text" placeholder="Phone number"></b-form-input>
								<b-form-invalid-feedback id="input-1-live-feedback">
									Phone is required
								</b-form-invalid-feedback>
							</b-col>
						</b-row>

						<b-row class="my-1">
							<b-col sm="2">
								<img class="icono-upload" src="~Img/baseline-comment-24px.svg" >
							</b-col>
							<b-col sm="12" md="10" >
								<b-form-textarea v-model="form.comment" id="textarea1" placeholder="Enter something" :rows="3" :max-rows="6"></b-form-textarea>
							</b-col>
						</b-row>
				</div>

				<div class="send-content">
					<!-- <b-spinner class="upload-spinner" v-if="sending" variant="primary" label="Loading..."></b-spinner> -->
					<!-- <b-button class="send-boton" variant="primary"  @click="uploadValidation">SEND FILES</b-button> -->
					<a @click="uploadValidation">
						<easyBtn  btnText="Send Files" />
					</a>
				</div>
			</div>
		</form>

	</div>
</template>

<script>
import Vue from 'vue'
import bus from '@/commonSite/eventBus.js'
import easyBtn from 'Common/components/easy-btn.vue'
import { validationMixin } from 'vuelidate'
import {
	required,
	minLength,
	email
} from 'vuelidate/lib/validators'

const STATUS_INITIAL = 0
const STATUS_ADDED = 1
const STATUS_SAVING = 2
const STATUS_SUCCESS = 3
const STATUS_FAILED = 4

export default {
	name: 'upload-file',
	components: { easyBtn },
	data: function () {
		return {
			multiple: null,
			type: this.uploadType,
			uploadedFiles: [],
			uploadError: null,
			currentStatus: STATUS_INITIAL,
			uploadFieldName: 'projectFiles',
			formData: null,
			fileCount: 0,
			sending: false,
			form: {
				projectName: '',
				projectType: '',
				from: '',
				email: '',
				phone: '',
				comment: ''
			},
			isDropboxOption: false,
			mailMessage: ''
		}
	},
	mixins: [validationMixin],
	props: ['uploadType'],
	validations: {
		form: {
			projectName: {
				required,
				minLength: minLength(3)
			},
			projectType: {
				required
			},
			from: {
				required,
				minLength: minLength(3)
			},
			email: {
				required,
				email
			},
			phone: {
				required,
				minLength: minLength(5)
			}
		}
	},
	computed: {
		isInitial () {
			return this.currentStatus === STATUS_INITIAL
		},
		isSaving () {
			return this.currentStatus === STATUS_SAVING
		},
		filesAdded () {
			return this.currentStatus === STATUS_ADDED
		},
		isSuccess () {
			return this.currentStatus === STATUS_SUCCESS
		},
		isFailed () {
			return this.currentStatus === STATUS_FAILED
		}
	},
	methods: {
		getValidationClass (fieldName) {
			const field = this.$v.form[fieldName]

			if (field) {
				return {
					'md-invalid': field.$invalid && field.$dirty
				}
			}
		},
		reset () {
			// reset form to initial state
			this.currentStatus = STATUS_INITIAL
			this.uploadedFiles = []
			this.uploadError = null
			this.form = {
				projectName: '',
				projectType: '',
				from: '',
				email: '',
				phone: '',
				comment: ''
			}
		},
		save () {
			// upload data to the server
			this.formData.append('projectName', this.form.projectName)
			this.formData.append('projectType', this.form.projectType)
			this.formData.append('from', this.form.from)
			this.formData.append('email', this.form.email)
			this.formData.append('phone', this.form.phone)
			this.formData.append('comment', this.form.comment)
			this.formData.append('hasDropbox', this.isDropboxOption)
			this.currentStatus = STATUS_SAVING
			this.sending = true
			Vue.e24Common.prjFilesService.upload(this.formData).then(() => {
				this.sending = false
				this.reset()
				this.$v.$reset()
				this.$root.$emit('bv::hide::modal', 'modalFull', '#btnShow')
			})
		},
		filesChange (fieldName, fileList) {
			// handle file changes
			this.formData = new FormData()

			if (!fileList.length) return

			this.currentStatus = STATUS_ADDED
			// append the files to FormData
			Array
				.from(Array(fileList.length).keys())
				.map(x => {
					console.log('File', fieldName, fileList[x], fileList[x].name)
					this.formData.append(fieldName, fileList[x], fileList[x].name)
				})

			// this.formData.append('dataTest', 'Hello world')
			// Vue.e24Common.prjFilesService.upload(formData)
			// this.formData = formData
			console.log('formData', this.formData)
		},
		uploadValidation () {
			// this.$bvModal.hide('modalFull')
			this.$v.$touch()

			if (!this.$v.$invalid && this.fileCount > 0) {
				this.save()
				bus.$emit('files-sended', this.sending)
			} else {
				console.log('Please complete all fields!')
			}
		}
	},
	mounted () {
		this.reset()
	}
}
</script>

<style lang="less">
@import url('~Css/variable');
@import url('~Css/responsive');

.label-add{
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	min-height: 120px;
	width: 100%;
	// border: 1px solid red;
	label{
		margin-top: 5px;
	}
}

.send-content{
				// border: 1px solid pink;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin-right: 5px;

	.send-boton{
		margin: 10px 10px;
		padding: 5px 15px;
	}
}

.my-1{
		padding: 5px 0px;
		.icono-upload{
			.small-device({
				display: none;
			});
		}
	}

	.form-field{
		display: flex;
		flex-direction: column;
		justify-items: center;
		width: 98%;
		//border: 1px solid blue;

		.my-1{
			// border: 1px solid red;
			margin-left: 0%;
		}
	}
	.container-select{

		padding: 8px;
		.selected--uploadFiles{
			width: 100%;
			// padding: 15px 0;
		}
		.label-type{
			text-align: center;
			background-color: rgba(0,0,255,.4);
		}
	}

</style>



// WEBPACK FOOTER //
// src/commonSite/uploadFiles.vue